module.exports = __webpack_public_path__ + "assets/img/phone.6eb0e320.jpg";